import {Grid} from '@material-ui/core';
import React from 'react';
import {useAuthenticated} from 'react-admin';
import {StudentQuizDashboard} from "../../../pages/dashboards/quiz/student-dashboard";
import {TeacherQuizDashboard} from "../../../pages/dashboards/quiz/teacher-dashboard";


const QuizDashboard = ({ isStudent, ...props }) => {

    useAuthenticated()

    if (isStudent) {
        return (
            <Grid container>
                <StudentQuizDashboard />
            </Grid>
        )
    }

    return (
        <Grid container>
            <TeacherQuizDashboard />
        </Grid>
    )

}

export default QuizDashboard;